import { render, staticRenderFns } from "./SliderComponent.html?vue&type=template&id=6a2ef502&scoped=true&"
import script from "./SliderComponent.js?vue&type=script&lang=js&"
export * from "./SliderComponent.js?vue&type=script&lang=js&"
import style0 from "./SliderComponent.scss?vue&type=style&index=0&id=6a2ef502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ef502",
  null
  
)

export default component.exports